import { FolderTree } from 'lucide-react';

export function ClassificationPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <FolderTree className="h-6 w-6 text-muted-foreground" />
        <h1 className="text-2xl font-semibold">Classification</h1>
      </div>
      <p className="text-muted-foreground">Coming soon — manage classification views and document organization.</p>
    </div>
  );
}
